import React, { FC } from 'react';
import { FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { PlannerBundle, PlannerOrder } from '../utils/usePlannerData';
import { addSelectedOrdersToBundleWrapper } from '../../oldPlanner/utils/bundleDraft';

export const PlannerToolsSelectedOrders: FC<{
  selectedOrders: PlannerOrder[];
  bundles: PlannerBundle[];
  clearSelectedOrders: () => void;
  handleOrderSelect: (orders: PlannerOrder[]) => void;
  reFetch: () => void;
}> = ({
  selectedOrders,
  bundles,
  clearSelectedOrders,
  handleOrderSelect,
  reFetch,
}) => (
  <div className="selected-orders">
    <div className="header">
      <strong>
        Orders selected <strong>({selectedOrders.length})</strong>
      </strong>
      <button className="button" onClick={clearSelectedOrders}>
        Clear
      </button>
    </div>
    <div className="tools-line" />
    <div>
      {selectedOrders.map(order => (
        <div key={order.id} className="selected-order">
          <Link
            to={`/orders/${order.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {order.id}
          </Link>
          <div>{order.pickupName}</div>
          <div>{order.window}</div>
          <button onClick={() => handleOrderSelect([order])}>
            <FaTimes />
          </button>
        </div>
      ))}
    </div>
    Add selected to bundle
    <div className="bundles">
      {bundles.map(bundle => (
        <button
          key={bundle.id}
          style={{ backgroundColor: bundle.color, color: bundle.textColor }}
          onClick={() =>
            addSelectedOrdersToBundleWrapper(
              bundle.id,
              selectedOrders,
              reFetch,
              clearSelectedOrders
            )
          }
        >
          {bundle.id}
        </button>
      ))}
    </div>
  </div>
);
